import { FC } from 'react';
import { ConfirmDialogProps } from './ConfirmDialog.types';
import { Dialog, Flex, Button, ButtonGroup, Alert } from '@/_components';

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  isOpen,
  isLoading,
  message,
  title,
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog isOpen={isOpen} title={title} onClose={onClose}>
      <Dialog.Content>
        <Flex isColumn={true} gap={8}>
          <Alert type="info">{message}</Alert>
          <ButtonGroup align="right">
            <Button
              value={cancelText}
              intent="danger-secondary"
              isDisabled={isLoading}
              onClick={onClose}
            />
            <Button
              value={confirmText}
              intent="primary"
              onClick={onConfirm}
              isDisabled={isLoading}
              isLoading={isLoading}
            />
          </ButtonGroup>
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
};
